/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { AcceptancesControllerCheckStatusQueryResponse, AcceptancesControllerCheckStatusPathParams, AcceptancesControllerCheckStatus401 } from "../../models/acceptancesController/AcceptancesControllerCheckStatus";

function getAcceptancesControllerCheckStatusUrl(principalId: AcceptancesControllerCheckStatusPathParams["principalId"], principalType: AcceptancesControllerCheckStatusPathParams["principalType"], type: AcceptancesControllerCheckStatusPathParams["type"]) {
  const res = { method: 'GET', url: `/api/v1/acceptances/${principalType}/${principalId}/${type}` as const }  
  return res
}

/**
 * @summary Check acceptance status for a specific agreement type
 * {@link /api/v1/acceptances/:principalType/:principalId/:type}
 */
export async function acceptancesControllerCheckStatus(principalId: AcceptancesControllerCheckStatusPathParams["principalId"], principalType: AcceptancesControllerCheckStatusPathParams["principalType"], type: AcceptancesControllerCheckStatusPathParams["type"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<AcceptancesControllerCheckStatusQueryResponse, ResponseErrorConfig<AcceptancesControllerCheckStatus401>, unknown>({ method : "GET", url : getAcceptancesControllerCheckStatusUrl(principalId, principalType, type).url.toString(), ... requestConfig })  
  return res.data
}